import React, { useMemo } from 'react';
import usePreviewPpsi from 'features/PpsiContainer/hooks/usePreviewPpsi';
import { States } from '../features/PpsiContainer/constants';
import Table from '../components/Table/Table';
import useGlobalPublishedPpsisNir from '../features/PpsiContainer/hooks/useGlobalPublishedPpsisNir';
import useConnectDishToPpsiNir from '../features/PpsiContainer/hooks/useConnectDishToPpsiNir';
import usePpsisWithPpisNir from '../features/PpsiContainer/hooks/usePpsisWithPpisNir';
import useViewVisited from '../features/app/hooks/useViewVisted';
import ppsiColumns from '../features/PpsiContainer/ui/columnsNir';
import { toJS } from '../utils/immutableUtils';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import useDishes from '../features/DishContainer/hooks/useDishes';
import { MARKET_GLOBAL_LANG } from '../features/app/constants';
import useGlobalPpis from 'features/PpiContainer/hooks/useGlobalPpis';

const PpsiPublishedListGlobalNirView = () => {
  const dishesFilter = useMemo(
    () => ({
      isGlobalBased: false,
      hasPpsi: false
    }),
    []
  );
  const dishesStatus = 'NEW';
  const globalPpsitoLocalLanguage = false;

  const [isFetchingLocalDishes, localDishesRaw] = useDishes(
    dishesFilter,
    dishesStatus
  );

  const [isFetchingGlobalPpsis, ppsisRaw] = useGlobalPublishedPpsisNir(
    States.PUBLISHED,
    globalPpsitoLocalLanguage
  );

  const [isFetchingGlobalPpis, ppisRaw] = useGlobalPpis(States.PUBLISHED);

  const localDishes = toJS(localDishesRaw, []);
  const ppsis = toJS(ppsisRaw, []);
  const ppis = toJS(ppisRaw, []);

  const ppsisWithPpis = usePpsisWithPpisNir(ppsis, ppis, MARKET_GLOBAL_LANG);

  const [previewNode, openPreview] = usePreviewPpsi();
  const [dialog, onOpenDialog] = useConnectDishToPpsiNir(localDishes);

  const { isViewVisited } = useViewVisited(
    View.PpsiPublishedListGlobalNirView.name,
    isFetchingGlobalPpsis || isFetchingLocalDishes || isFetchingGlobalPpis
  );

  const isFetching =
    isFetchingGlobalPpsis || isFetchingLocalDishes || isFetchingGlobalPpis;
  const isFetched = !isFetching;

  const columnsBase = ppsiColumns(
    MARKET_GLOBAL_LANG,
    onOpenDialog,
    openPreview
  );
  const columns = [
    columnsBase.IfoodID,
    columnsBase.PresentationName,
    columnsBase.PiaNumber,
    columnsBase.Version,
    columnsBase.ActualPublishDate,
    columnsBase.CopyGlobalPpsi
  ];

  if (isFetched && !isViewVisited) {
    View.PpsiPublishedListGlobalNirView.visit();
  }

  return (
    <>
      {previewNode}
      <PaperContainer showProgress={isFetching && !isViewVisited}>
        <Table
          title="ppsi.publishedListGlobalNirTableTitle"
          data={ppsisWithPpis}
          columns={columns}
          getObjectId={object => object.id}
          defaultSorting={[
            { columnName: 'presentationName', direction: 'asc' }
          ]}
          selectable
          showLanguageSelector={false}
        />
        {dialog}
      </PaperContainer>
    </>
  );
};

export default PpsiPublishedListGlobalNirView;
